import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';

import Tag from '@components/labels/Tag';
import TextWithAvatar from '@components/TextWithAvatar';
import useMyExpert from '@hooks/useMyExpert';
import { ExpertRoleRoleEnum } from '@typing/Generated';

type ExpertRole = {
  expert: {
    firstName: string;
    id: string;
    photoUrl: string | null;
  };
  id: string;
  role: ExpertRoleRoleEnum;
};

type Props = {
  expertRoles?: ExpertRole[] | null;
};

const ExpertRoleBoxes = ({ expertRoles }: Props) => {
  const myExpertId = useMyExpert()?.id;
  const currentRole = useMemo(
    () => expertRoles?.find(role => role.expert.id === myExpertId),
    [expertRoles, myExpertId]
  );
  const primaryRole = useMemo(() => expertRoles?.find(role => role.role === ExpertRoleRoleEnum.primary), [expertRoles]);

  const stylesForRole = useCallback((role: ExpertRole) => {
    if (role.role === ExpertRoleRoleEnum.primary) {
      return 'primary300';
    }
    if (role.role === ExpertRoleRoleEnum.backup) {
      return 'secondary500';
    }
    return 'error500';
  }, []);

  const intl = useIntl();

  return (
    <IonGrid>
      <IonRow>
        {currentRole && (
          <IonCol className="ion-margin-end" size="auto">
            <Tag
              color={stylesForRole(currentRole)}
              text={intl.formatMessage({ id: `pages.expert.myRole.${currentRole.role}` })}
            />
          </IonCol>
        )}
        <IonCol size="auto">
          {primaryRole?.expert.id !== currentRole?.expert.id && (
            <TextWithAvatar
              color="primary300"
              photoUrl={primaryRole?.expert.photoUrl}
              text={intl.formatMessage({
                id: 'pages.expert.role.owner'
              })}
            />
          )}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default ExpertRoleBoxes;
